import { Reveal, Chapter } from "@/components/Reveal";

const REGIONS = [
  { n: "I", name: "Europe", note: "Established culinary capitals" },
  { n: "II", name: "Middle East", note: "Ultra-luxury hospitality markets" },
  { n: "III", name: "Asia", note: "Rapidly evolving destinations" },
];

const GlobalNetwork = () => (
  <section data-testid="network-section" className="bg-ivory py-28 lg:py-40 hairline">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <Reveal>
        <Chapter number="07" label="Global Network" />
      </Reveal>
      <div className="max-w-3xl">
        <Reveal delay={0.1}>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.08] text-ink">
            A Global Hospitality <span className="italic text-bronze">Network</span>
          </h2>
          <p className="mt-7 text-sm text-ink/60 leading-relaxed">
            From the established culinary capitals of Europe to the ultra-luxury hospitality
            markets of the Middle East and the rapidly evolving destinations of Southeast Asia, BR
            Hospitality connects exceptional properties with world-class talent across continents.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 lg:mt-24 border-t border-ink/10">
        {REGIONS.map((r, i) => (
          <Reveal key={r.name} delay={0.08 * i}>
            <div
              data-testid={`region-${r.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="group grid grid-cols-12 items-baseline gap-4 py-10 lg:py-14 border-b border-ink/10 hover:pl-4 transition-all duration-700"
            >
              <span className="col-span-2 lg:col-span-1 font-serif italic text-bronze text-lg">
                {r.n}
              </span>
              <h3 className="col-span-10 lg:col-span-7 font-serif text-4xl sm:text-5xl lg:text-7xl font-light text-ink group-hover:text-bronze transition-colors duration-700">
                {r.name.toUpperCase()}
              </h3>
              <p className="col-span-12 lg:col-span-4 text-[11px] tracking-[0.25em] uppercase text-ink/40 lg:text-right">
                {r.note}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default GlobalNetwork;
